import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../../../node_modules/@lit/reactive-element/decorators/state.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import SimpleBar from '../../../../node_modules/simplebar/dist/index.mjs.js';
import { ifDefined as l } from '../../../../node_modules/lit-html/directives/if-defined.js';
import { getFormAttributes } from '../../../common/metrics.js';
import { ImageBlock } from '../../organisms/image-block/index.js';
import { metricsTrack } from '../../utilities/analytics/index.js';
import { disableBodyScroll, enableBodyScroll } from '../../utilities/behavior-helpers/index.js';
import { isRTL } from '../../utilities/dom-helpers/index.js';
import css_248z from './modal-container.scss.js';
import img from '../../../../assets/images/cross-icon.svg.js';

class ModalContainer extends s {
    constructor() {
        super(...arguments);
        this.closeButtonText = 'Close';
        this.isVisible = false;
        this.isScrollable = false;
        this.modalContainer = null;
        this.modalInner = null;
        this.modal = null;
        this.simpleBar = null;
        this.modalHeight = 0;
        this.containerDiv = null;
        this.query = '(max-width: 400px)';
        this.isMobile = false;
        this.focusStartEl = null;
        this.focusEndEl = null;
        this.closeButton = null;
    }
    showModal() {
        this.isVisible = true;
        const { body } = document;
        body.style.top = `-${window.scrollY}px`;
        disableBodyScroll();
        const slot = this.shadowRoot.querySelector('slot');
        const form = slot.assignedNodes()[0].querySelector('.EPiServerForms ');
        if (form) {
            this.formEvent(form);
        }
        setTimeout(() => {
            this.modalContainer.style.height = 'calc(var(--vh-px, 1vh)*100)';
        }, 100);
    }
    hideModal() {
        this.isVisible = false;
        enableBodyScroll();
        if (window.CVTModalTargetElement) {
            setTimeout(() => {
                window.CVTModalTargetElement.focus();
            }, 100);
        }
        setTimeout(() => {
            this.modalContainer.style.height = '130vh';
        }, 100);
    }
    addCloseModalEvents() {
        this.modalContainer.addEventListener('click', () => this.hideModal());
        this.modal.addEventListener('click', (e) => e.stopPropagation());
        window.addEventListener('keydown', (e) => {
            if (this.isVisible && e.key === 'Escape')
                this.hideModal();
        });
    }
    getModalHeight() {
        this.modalHeight = this.modal.getBoundingClientRect().height;
    }
    setImagePaddings() {
        var _a;
        if (!this.modal)
            return;
        const content = this.modal.querySelector('slot[name="content"]');
        if (!content)
            return;
        const assignedElements = content.assignedElements()[0];
        (_a = assignedElements === null || assignedElements === void 0 ? void 0 : assignedElements.childNodes) === null || _a === void 0 ? void 0 : _a.forEach(element => {
            var _a;
            if (element instanceof ImageBlock) {
                (_a = element
                    .shadowRoot.querySelector('.image-block')) === null || _a === void 0 ? void 0 : _a.classList.add('in-modal');
                const img = element.querySelector('img');
                if (img) {
                    img.style.aspectRatio = '16 / 9';
                    img.style.borderRadius = '12px';
                }
            }
        });
    }
    formEvent(form) {
        metricsTrack('cevt_form_view', Object.assign(Object.assign({}, getFormAttributes(form)), { dlv_event_action: 'view' }));
    }
    firstUpdated() {
        var _a;
        this.containerDiv = document.querySelector('.container');
        this.moveModalToContainer();
        this.modalContainer = this.shadowRoot.querySelector('.modal-container');
        this.modalInner = (_a = this.modalContainer) === null || _a === void 0 ? void 0 : _a.querySelector('.modal-inner');
        this.modal = this.modalContainer.querySelector('.modal');
        this.setImagePaddings();
        this.addCloseModalEvents();
        if (this.showOnPageLoad)
            this.showModal();
        this.simpleBar = new SimpleBar(this.modalInner, {
            autoHide: false,
            scrollbarMinSize: 50,
        });
    }
    moveModalToContainer() {
        var _a;
        (_a = this.containerDiv) === null || _a === void 0 ? void 0 : _a.appendChild(this);
    }
    focusTrap() {
        var _a, _b;
        if (!this.focusStartEl) {
            this.focusStartEl = document.createElement('input');
            this.focusStartEl.setAttribute('aria-disabled', 'true');
            this.focusStartEl.setAttribute('aria-hidden', 'true');
        }
        (_a = this.modalInner) === null || _a === void 0 ? void 0 : _a.prepend(this.focusStartEl);
        if (!this.focusEndEl) {
            this.focusEndEl = document.createElement('input');
            this.focusEndEl.setAttribute('aria-disabled', 'true');
            this.focusEndEl.setAttribute('aria-hidden', 'true');
            (_b = this.modalInner) === null || _b === void 0 ? void 0 : _b.append(this.focusEndEl);
            this.focusEndEl.addEventListener('focus', () => {
                var _a, _b;
                const closeButton = (_b = (_a = this.renderRoot
                    .querySelector('icon-button')) === null || _a === void 0 ? void 0 : _a.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector('button');
                closeButton === null || closeButton === void 0 ? void 0 : closeButton.focus();
            });
        }
        this.focusEndEl.focus();
        this.focusEndEl.blur();
        setTimeout(() => {
            var _a;
            (_a = this.focusStartEl) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ block: 'end' });
        }, 10);
    }
    _handleMediaQuery(event) {
        this.isMobile = event.detail.value;
    }
    updated() {
        this.getModalHeight();
        if (this.isVisible) {
            if (this.showOnPageLoad) {
                setTimeout(() => {
                    this.focusTrap();
                }, 300);
            }
            else {
                this.focusTrap();
            }
            this.addEventListener('keydown', (event) => {
                const shift = event.shiftKey;
                const { activeElement } = document;
                if (event.key === 'Tab' && shift && activeElement === this) {
                    event.preventDefault();
                }
            });
        }
    }
    render() {
        return $ `<dialog class="modal-container ${this.isVisible ? 'show' : ''} ${this
            .isScrollable
            ? 'scrollable'
            : ''} ${this.rtl || isRTL() ? 'rtl' : ''}" ?open="${this.isVisible}" popup-id="${l(this.popupId)}"><div class="modal modal-outer"><div class="modal-inner"><icon-button class="close-button" .onClick="${() => this.hideModal()}" ariaLabel="${this.closeButtonText}" fixedSize><img slot="icon" .src="${img}" alt="" aria-hidden="true"></icon-button><slot name="content"></slot></div></div></dialog><lit-media-query .query="${this.query}" @changed="${this._handleMediaQuery}"></lit-media-query>`;
    }
}
ModalContainer.styles = css_248z;
__decorate([
    e({ type: String })
], ModalContainer.prototype, "popupId", void 0);
__decorate([
    e()
], ModalContainer.prototype, "closeButtonText", void 0);
__decorate([
    e({ type: Boolean })
], ModalContainer.prototype, "showOnPageLoad", void 0);
__decorate([
    e({ type: Boolean })
], ModalContainer.prototype, "rtl", void 0);
__decorate([
    t()
], ModalContainer.prototype, "isVisible", void 0);
__decorate([
    t()
], ModalContainer.prototype, "isScrollable", void 0);
__decorate([
    t()
], ModalContainer.prototype, "modalContainer", void 0);
__decorate([
    t()
], ModalContainer.prototype, "modalInner", void 0);
__decorate([
    t()
], ModalContainer.prototype, "modal", void 0);
__decorate([
    t()
], ModalContainer.prototype, "simpleBar", void 0);
__decorate([
    t()
], ModalContainer.prototype, "modalHeight", void 0);
__decorate([
    t()
], ModalContainer.prototype, "containerDiv", void 0);
__decorate([
    t()
], ModalContainer.prototype, "query", void 0);
__decorate([
    t()
], ModalContainer.prototype, "isMobile", void 0);
customElements.define('cvt-modal', ModalContainer);

export { ModalContainer };
